import * as React from "react";
import { IFormInputBaseWithValidation } from "soprasteria-ui-library/dist/models/IFormInput";
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

interface ISearchPatient extends IFormInputBaseWithValidation {
    clearSearchPatientInputButtonId: string;
}

export const SearchPatientInput: React.FunctionComponent<ISearchPatient> = ({ name, label, required, clearSearchPatientInputButtonId }) => {

    const { errors, register, clearError } = useFormContext();
    const valid = (type: string) => {
        return [name] && (errors[name] as any)?.type === type;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const trimmedValue = e.target.value.trim();
        e.target.value = trimmedValue;
        if (trimmedValue.match(/^(19|20)(\d{6}(-?|\s)\d{4}|(?!19|20)\d{10})$|[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/)) {
            clearError(name);
        }
    }

    return (
        <div className="input-group">
            <input type="text"
                name={name}
                id={name}
                className={"form-control form-control-sm " + (errors ? valid("pattern") && "is-invalid" : "")}
                placeholder={label}
                ref={register({ required: required, pattern: /^(19|20)(\d{6}(-?|\s)\d{4}|(?!19|20)\d{10})$|[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/ })}
                autoComplete="off"
                onChange={handleChange}
            />
            <input type="reset" className="d-none" id={clearSearchPatientInputButtonId} />
            <button type="submit"><FontAwesomeIcon icon={faSearch} /></button>
            <span className="text-danger" >{errors ? valid("pattern") && "Fel format" : ""}</span>
        </div>
    )
}